import React, { useContext } from "react";
import { FormattedNumber } from "react-intl";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import SupplierContext from "../../../contexts/SupplierContext";
import OwLabel from "../OwLabel/OwLabel";
import OrderEntryService from "../../../services/OrderEntryService";
import IOrder_Item from "../../../models/IOrder_Item";
import { getPackItemPackCount } from "../../../services/CatalogItemService";

type Props = {
    item: IOrder_ItemUI | IOrder_Item;
    className?: string;
    // When true, pack lines display the headline qty in whole packs (matching the editor) with the units as a sub-line.
    showPacks?: boolean;
};

export const QtyDetail = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const catalogItem = props.item.Catalog_Item;
    const packMode = !!(
        props.showPacks &&
        catalogItem?.has_pack_qty &&
        catalogItem?.pack_qty &&
        catalogItem.pack_qty >= 1 &&
        !catalogItem.price_per_pack &&
        !props.item.uom_set_id
    );

    if (props.item.uom_set_id) {
        // const uomSetQtyConversion = OrderService.getUomSetQty(
        //     props.item.qty || 1,
        //     props.item.Catalog_Item?.Base_Unit,
        //     props.item.Selected_Unit
        // );
        const uomSetQtyConversion = props.item.qty;

        let showUomSetConversion = false;

        if (uomSetQtyConversion) {
            showUomSetConversion = true;

            if (!supplierModel.hide_uom_base_qty) {
                showUomSetConversion = false;
            }

            if (supplierModel.allow_manual_uom_base_qty) {
                showUomSetConversion = false;
            }
        }

        return (
            <div className={props.className}>
                <div>
                    <FormattedNumber value={Number(props.item.uom_set_qty)} minimumFractionDigits={supplierModel.qty_precision} />
                </div>
                {showUomSetConversion ? (
                    <div className={"text-small mb-2"}>
                        {uomSetQtyConversion} {props.item.Catalog_Item?.Base_Unit?.unit_abbr}
                    </div>
                ) : null}
            </div>
        );
    } else if (packMode && catalogItem) {
        // Headline in whole packs, units as a small sub-line — mirrors the UOM-set display above.
        return (
            <div className={props.className}>
                <div>{getPackItemPackCount(catalogItem, Number(props.item.qty))}</div>
                <div className={"text-small mb-2"}>
                    <FormattedNumber value={Number(props.item.qty)} minimumFractionDigits={supplierModel.qty_precision} />{" "}
                    {catalogItem.Base_Unit?.unit_abbr}
                </div>
            </div>
        );
    } else {
        return <FormattedNumber value={Number(props.item.qty)} minimumFractionDigits={supplierModel.qty_precision} />;
    }
};
